module.exports = __webpack_public_path__ + "static/media/collection-crossed-hockey-svgrepo-com.88e3cb97.svg";